import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 40px;
  padding: 36px;
  overflow-y: auto;
  height: calc(100vh - 260px);
  padding-top: 56px;
  box-sizing: content-box;
`;
